
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"160","height":"161","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"80","cy":"80.018","r":"80","fill":"#E0E0E0"}}),_c('g',{attrs:{"opacity":".75","fill-opacity":".5"}},[_c('path',{attrs:{"d":"M42.03 75.996h74.462v57.58a.443.443 0 01-.44.442H42.469a.438.438 0 01-.44-.442v-57.58z","fill":"#7A7A7A"}}),_c('path',{attrs:{"d":"M97.812 53.432H63.188L42.03 75.996h74.463l-18.68-22.564z","fill":"#4F4F4F"}}),_c('path',{attrs:{"d":"M49.082 44.407l14.106 9.025L42.03 75.996 26 63.747l23.082-19.34zM111.918 44.407l-14.106 9.025 18.68 22.564L135 63.747l-23.082-19.34z","fill":"#7A7A7A"}}),_c('path',{attrs:{"d":"M72.285 44.868c.398-.19.708-.527.864-.94a1.725 1.725 0 00-.024-1.281L66.78 27.602a1.717 1.717 0 00-.965-.935 1.699 1.699 0 00-1.339.053l-1.222.583a1.709 1.709 0 00-.889 1.009 1.726 1.726 0 00.11 1.342l7.567 14.462a1.699 1.699 0 002.243.752zM80.24 43.41c.288-.021.557-.153.751-.368a1.13 1.13 0 00.289-.788l-.314-10.71a1.131 1.131 0 00-.754-1.032 1.113 1.113 0 00-.444-.059l-.885.064a1.115 1.115 0 00-.993.8 1.131 1.131 0 00-.04.449l1.198 10.647c.033.289.175.554.397.74.222.185.507.277.795.257zM86.382 47.369c.793.46 1.905.038 2.522-.959L99.86 28.72c.654-1.058.499-2.346-.341-2.834l-1.172-.681c-.84-.49-2.028.018-2.612 1.116L85.95 44.693c-.55 1.035-.36 2.215.432 2.676z","fill":"#999"}})])])
          )
        }
      }
    